if ( typeof ShippingProgress !== 'function' ) {

  class ShippingProgress extends HTMLElement {

    constructor() {
      super();
      if (this.hasAttribute('data-initialized')) {
        return;
      }
      this.setAttribute('data-initialized', 'true');
      this.init();
    }

    init() {
      this.freeShippingThreshold = Number(this.getAttribute('data-free-shipping'));
      this.cartTotal = Number(this.getAttribute('data-cart-total-amount'));

      this.messageRemaining = this.getAttribute('data-message-remaining') || 'Nog [amount] tot gratis verzending.';
      this.messageSuccess = this.getAttribute('data-message-success') || 'Je komt in aanmerking voor gratis verzending!';

      if ( isNaN(this.freeShippingThreshold) || this.freeShippingThreshold <= 0 || isNaN(this.cartTotal) ) {
        return;
      }

      this.render();
      this.updateProgress();

      document.addEventListener('cart-updated', this.handleCartUpdate.bind(this));
    }

    handleCartUpdate() {
      const cartForm = document.getElementById('AjaxCartForm');
      if ( !cartForm ) return;

      const cartTotalElement = cartForm.querySelector('[data-cart-total]');
      if ( !cartTotalElement ) return;

      this.cartTotal = this.parseMoney(cartTotalElement.textContent);
      this.updateProgress();
    }

    updateCartTotal(cartTotal) {
      this.cartTotal = cartTotal;
      this.updateProgress();
    }

    /* Kopstorm, 2 Oct 2026 (Derk, Smooche reference): message on top, a full width
       bar underneath with the delivery icon at the end, so it is clear at a glance
       how far the order is from free shipping. The icon comes from the theme's own
       icon pack through a template tag rendered in Liquid. */
    render() {
      const iconTpl = this.querySelector('template[data-kst-ship-icon]');
      const icon = iconTpl ? iconTpl.innerHTML : '';
      this.innerHTML = `
        <div class="shipping-progress shipping-progress--bar">
          <div class="shipping-progress__message">
            <div class="shipping-progress__message-text"></div>
          </div>
          <div class="shipping-progress__track" aria-hidden="true">
            <span class="shipping-progress__fill"></span>
            ${icon ? `<span class="shipping-progress__icon">${icon}</span>` : ''}
          </div>
        </div>
      `;

      this.wrapper = this.querySelector('.shipping-progress');
      this.messageText = this.querySelector('.shipping-progress__message-text');
    }

    updateProgress() {
      const percentage = Math.max(0, Math.min((this.cartTotal / this.freeShippingThreshold) * 100, 100));

      if ( this.wrapper ) {
        this.wrapper.style.setProperty('--kop-progress', percentage.toFixed(2));
        this.wrapper.classList.toggle('shipping-progress--complete', percentage >= 100);
      }

      this.updateMessage();
    }

    updateMessage() {
      if ( !this.messageText ) return;

      if ( this.cartTotal >= this.freeShippingThreshold ) {
        this.messageText.innerHTML = this.messageSuccess;
        return;
      }

      const remaining = this.freeShippingThreshold - this.cartTotal;
      const amount = '<strong>' + this.formatMoney(remaining) + '</strong>';
      this.messageText.innerHTML = this.messageRemaining.split('[amount]').join(amount);
    }

    /* "€32,50" -> 3250 */
    parseMoney(text) {
      const cleaned = String(text)
        .replace(/[^\d.,-]/g, '')
        .replace(/\.(?=\d{3}\b)/g, '')
        .replace(',', '.');
      const value = parseFloat(cleaned);
      return isNaN(value) ? this.cartTotal : Math.round(value * 100);
    }

    formatMoney(cents) {
      try {
        const currency = ( window.Shopify && Shopify.currency && Shopify.currency.active ) || 'EUR';
        const locale = document.documentElement.lang || 'nl';
        return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(cents / 100);
      } catch (e) {
        return '€' + (cents / 100).toFixed(2).replace('.', ',');
      }
    }

  }

  if ( typeof customElements.get('shipping-progress') == 'undefined' ) {
    customElements.define('shipping-progress', ShippingProgress);
  }

}
